module.exports = __webpack_public_path__ + "static/img/take-picture2.6514f7e.png";